import AppHeader from "../../layout/AppHeader";
import Packing from '../../xpost/views/register/packing/Packing.vue';
import PackingAdd from '../../xpost/views/register/packing/PackingAdd.vue';

const PackingRoutes = [
    {
        path: "/cadastro/embalagem",
        name: "packing",
        components: {
            header: AppHeader,
            default: Packing,
        }
    },
    {
        path: "/cadastro/embalagem/adicionar",
        name: "packing.add",
        components: {
            header: AppHeader,
            default: PackingAdd,
        }
    },
    {
        path: '/cadastro/embalagem/adicionar/:id',
        name: 'packing.edit',
        components: {
            header: AppHeader,
            default: PackingAdd,
        }
    }
]

export default PackingRoutes;